import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// custom modules
import { AppRoutingModule } from './app-routing.module';

// core components
import { AppComponent } from './eStore/components/app/app.component';
import { ButtonComponent } from './core/components/button/button.component';
import { ContainerComponent } from './core/components/container/container.component';
import { ContainerItemComponent } from './core/components/container/nested/item/container-item.nested';
import { ContainerWrapOptionsComponent } from './core/components/container/nested/options/container-wrap.option';
import { TextBoxComponent } from './core/components/text-box/text-box.component';
import { ToolbarComponent } from './core/components/toolbar/toolbar.component';
import { ToolbarItemComponent } from './core/components/toolbar/nested/item/toolbar-item.nested';
import { TooltipComponent } from './core/components/tooltip/tooltip.component';

// core services
import { IdRegisterService } from './core/services/id-register.service';
import { OverlayService } from './core/services/overlay.service';
import { RendererService } from './core/services/rendererService';
import { SlideShowComponent } from './core/components/slideshow/slideshow.component';

// eStore components
import { HomeComponent } from './eStore/components/home/home.component';
import { StoreListComponent } from './eStore/components/store-list/store-list.component';
import { StoreNavComponent } from './eStore/components/store-nav/store-nav.component';

@NgModule({
    declarations: [
        AppComponent,
        ButtonComponent,
        ContainerComponent,
        ContainerWrapOptionsComponent,
        ContainerItemComponent,
        SlideShowComponent,
        TextBoxComponent,
        ToolbarComponent,
        ToolbarItemComponent,
        TooltipComponent,


        HomeComponent,
        StoreListComponent,
        StoreNavComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule
    ],
    providers: [
        IdRegisterService,
        OverlayService,
        RendererService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./client-src/app/app.module.ts